import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { URL_BUSCAR } from "../../../../../Components/Routes/Location";
import { ACTIVE_CLASS } from "../../../../../Utils/Constants";

// OTT-1966: la lupa deja de desplegar un buscador inline y enlaza directamente a /buscar.
// Se marca como activa solo dentro de /buscar, igual que el resto de items del menú
// (TopMenuSectionLink/TopMenuDropdownLink: NavLink + ACTIVE_CLASS, sin fondo fijo en reposo).
const SearchLink = () => {
  const { t } = useTranslation();
  return (
    <NavLink to={URL_BUSCAR} className="SearchLinkButton" activeClassName={ACTIVE_CLASS} aria-label={t("search.open.aria")}>
      <ion-icon name="search-outline" />
    </NavLink>
  );
};

export default SearchLink;
